import { apolloClient } from "@/plugins/vue-apollo.js";

const updateSettings = async (_variables) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;
  // debugger
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/contactUs/update_settings.graphql"),
      variables: variables,
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { updateSettings };
